module.exports = __webpack_public_path__ + "cf85813c7207f0c060fe036452ab11eb.pdf";